import { useLoader } from "../context/LoaderContext";
import logo from "../images/logo/logo.png"

const Preloader = () => {
  const { loading } = useLoader();

  return (
    <>
      {loading ? (
        <div className="loader-mask">
          <div className="preloader">
            <img src={logo} alt="Logo" className="preloader-logo" />
          </div>
        </div>
      ) : (
        <div></div>
      )} 
    </>
  );
};

export default Preloader;
